import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearPaymentMethods,
  getPaymentMethods,
} from '../../../../actions/accounting/PaymentMethod';
import { PAYMENT_METHOD_PATH, NEW_PAYMENT_METHOD_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import {  PAYMENT_METHOD_COLUMNS } from '../../../../config/columns';

export const PaymentMethods = ({
  breadcrumbs,
  paymentMethod,
  loading,
  dispatchGetPaymentMethods,
  dispatchClearPaymentMethods,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearPaymentMethods();
    },
    [],
  );

  const data = paymentMethod.get('content') || [];
  const pages = paymentMethod.get('totalPages') || null;
  const defaultPageSize = paymentMethod.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Métodos de Pago"
      buttonPath={NEW_PAYMENT_METHOD_PATH}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: PAYMENT_METHOD_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetPaymentMethods,
        loading,
        modelPath: PAYMENT_METHOD_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetPaymentMethods: getPaymentMethods,
  dispatchClearPaymentMethods: clearPaymentMethods,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Métodos de Pago',
      href: PAYMENT_METHOD_PATH,
    },
  ],
  paymentMethod: AccountingUnit.PaymentMethod.getIn(['all', 'content']),
  loading: AccountingUnit.PaymentMethod.getIn(['all', 'loading']),
});

PaymentMethods.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  paymentMethod: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetPaymentMethods: PropTypes.func.isRequired,
  dispatchClearPaymentMethods: PropTypes.func.isRequired,
};

PaymentMethods.defaultProps = {
  paymentMethod: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);
